(function (w, $) {
    const $personalDataCont = $('.js-personal-data-cont');
    if (!$personalDataCont.length) {
        return;
    }

    let downloadClicked = false;

    const $frame = $personalDataCont.find('#downloadPersonalDataFrame');
    $frame.load(function () {
        //note: load event is invoked when an error is returned from server
        //some browsers raise frame.load event on page load - need to check if download link was clicked
        if (!downloadClicked) {
            return;
        }

        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        let errTxt = TopFormText.downloadPersonalDataError;
        const frameContent = $frame[0].contentWindow || $frame[0].contentDocument;
        const frameDoc = frameContent.document || frameContent;

        if (frameDoc &&
            frameDoc.body !== null &&
            frameDoc.body.innerText !== null &&
            frameDoc.body.innerText.length) {
            try {
                const contentObj = JSON.parse(frameDoc.body.innerText);
                if (contentObj && contentObj.Message) {
                    errTxt = contentObj.Message;
                }
            } catch (e) {
                console.error(e);
            }
        }

        w.PubSub.publish('notification.error', errTxt);
    }); 

    $('.js-lnk-personal-data').click(function (e) {
        e.preventDefault();
        downloadClicked = true;
        const format = $(this).data('format');

        if (format) {
            const form = document.createElement('form');
            form.action = w.R + 'handlers/public/userdata.ashx';
            form.method = 'GET';
            form.target = 'downloadPersonalDataFrame';

            const dataInput = document.createElement('textarea');
            dataInput.name = 'action';
            dataInput.value = 'DownloadPersonalData';
            form.appendChild(dataInput);

            const formatInput = document.createElement('textarea');
            formatInput.name = 'format';
            formatInput.value = format;
            form.appendChild(formatInput);

            form.style.display = 'none';
            document.body.appendChild(form);
            form.submit();

            $(form).remove();
        } else {
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            w.PubSub.publish('notification.error', TopFormText.formatNotSpecified);
        }
    });
})(window, jQuery);